export default function Logo({ size = 28 }: { size?: number }) {
  return (
    <span className="logo" aria-hidden="false">
      <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        role="img"
        aria-label="Sendoc logo"
      >
        <rect width="32" height="32" rx="7" fill="#1e2a4a" />
        <path
          d="M10 7h8l5 5v13a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 9 25V8.5A1.5 1.5 0 0 1 10.5 7Z"
          fill="#fff"
          opacity="0.94"
        />
        <path d="M18 7l5 5h-4.4a.6.6 0 0 1-.6-.6V7Z" fill="#c7d2ee" />
        <rect x="12" y="15" width="8" height="1.6" rx="0.8" fill="#4a63d8" />
        <rect x="12" y="18.4" width="8" height="1.6" rx="0.8" fill="#8fa3e8" />
        <rect x="12" y="21.8" width="5" height="1.6" rx="0.8" fill="#8fa3e8" />
      </svg>
      <span className="logo-word">
        Sen<span className="logo-word-accent">doc</span>
      </span>
    </span>
  );
}
